<template>
	<div v-if="items.length > 0">
		<div v-for="(apps, category) in appsByCategories" :key="category">
			<template v-if="apps?.length > 0">
				<div class="title-container width-100 display-flex flex-row flex-align-center">
					<div class="title-text">{{ category }}</div>
				</div>
				<div v-for="(app, index) in apps" :key="app.id + '_' + index">
					<InterfaceMenuItem :app="app" v-on="$listeners" v-if="isInterfaceItem(app) && index === 0" :focusedItemUUID="focusedItemUUID" />
					<SubMenuItem
						v-else
						:app="app"
						v-on="$listeners"
						:focusedItemUUID="focusedItemUUID"
						:doesContextualNodeHaveContextualActions="app.id === contextualNodeServiceId && doesContextualNodeHaveContextualActions"
					/>
				</div>
			</template>
		</div>
		<div class="create-ai-helper py-1 ma-4 flex-centerize" v-if="isPlyHelpers && isAiFeatureFlagOn" @click="onCreateCodeHelperClicked">
			<AppIcon class="mr-1" name="small-stars"></AppIcon>
			Create a code helper with AI
		</div>
		<div v-if="!showAllItems" @click="onSeeAll" class="see-all-link flex-centerize py-1 mt-1 width-100">See all</div>
	</div>
</template>

<script>
import { isAiCodeGeneratorEnabled } from '@/store/modules/featureFlags/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import SubMenuItem from './SubMenuItem.vue';
import InterfaceMenuItem from './InterfaceMenuItem.vue';
import { INTERFACE } from '../BlockEditorAppSelect/BlockEditorAppSelect.const';
import { ServiceSlugs, ServiceType } from '@ply-io/ply-front-shared-utilities';

export default {
	name: 'AppSelectSubMenu',
	components: {
		SubMenuItem,
		InterfaceMenuItem,
	},
	props: {
		items: { type: Array },
		title: { type: String },
		actionType: { type: String },
		showAllItems: { type: Boolean },
		hasMoreItems: { type: Boolean },
		focusedItemUUID: { type: String },
		allNodesServiceSlugs: { type: Array },
		numOfElementsToDisplay: { type: Number },
		contextualNodeServiceId: { type: Number },
		doesContextualNodeHaveContextualActions: { type: Boolean },
	},

	computed: {
		...mapGettersShorthand({ isAiCodeGeneratorEnabled }),
		isAiFeatureFlagOn() {
			return this.isAiCodeGeneratorEnabled;
		},
		isPlyHelpers() {
			return this.actionType === this.ServiceTypes.Ply;
		},
		appsOnDisplay() {
			const numOfAppsToDisplay = this.showAllItems ? this.items.length : this.numOfElementsToDisplay;
			return this.items.slice(0, numOfAppsToDisplay);
		},
		appsByCategories() {
			const ALLOWED_ACTION_TYPES_FOR_USED_IN_FEATURE = [ServiceType.Integration];
			if (this.showAllItems && ALLOWED_ACTION_TYPES_FOR_USED_IN_FEATURE.includes(this.actionType)) {
				const usedInThisFeature = this.items.filter((app) => this.allNodesServiceSlugs?.includes(app.service_slug));
				return {
					'Used in this feature': usedInThisFeature,
					[`${usedInThisFeature?.length > 0 ? 'More ' : ''}${this.title}`]: this.items.filter(
						(app) => !this.allNodesServiceSlugs?.includes(app.service_slug)
					),
				};
			} else {
				return { [this.title]: this.appsOnDisplay };
			}
		},
	},
	methods: {
		onCreateCodeHelperClicked() {
			this.$emit('create-code-helper-clicked');
		},
		onSeeAll() {
			this.$emit('show-all', this.actionType);
		},
		isInterfaceItem(app) {
			return this.actionType === INTERFACE && app.service_slug === ServiceSlugs.Widgets;
		},
	},
	data() {
		return { ServiceTypes: ServiceType };
	},
};
</script>

<style scoped lang="scss">
$side-padding: 20px;

.create-ai-helper {
	box-shadow: 0px 3px 6px #e8ebf5;
	border: 1px solid #e8ebf4;
	border-radius: 8px;
	opacity: 1;
	background: #ffffff 0% 0% no-repeat padding-box;
	cursor: pointer;
	&:hover {
		background-color: var(--app-selection-hover-background);
	}
}
.title-container {
	margin: 8px 0px;
	padding: 8px $side-padding;
	background-color: var(--sub-menu-background);

	.title-text {
		font-size: 12px;
		color: var(--bold-title);
	}
}
.see-all-link {
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: rgb(0, 128, 247);
	text-decoration: underline;
	&:hover {
		background-color: var(--app-selection-hover-background);
	}
}
</style>
